import { Link } from "react-router-dom";
import "./LegalLinks.css";

interface LegalLinksProps {
  className?: string;
  onClick?: () => void;
}

/** "Terms · Privacy" links shown in the sidebar footer and signed-out screens. */
export function LegalLinks({ className = "legal-links", onClick }: LegalLinksProps) {
  return (
    <nav className={className} aria-label="Legal">
      <Link to="/terms" onClick={onClick}>Terms of Service</Link>
      <span aria-hidden="true"> · </span>
      <Link to="/privacy" onClick={onClick}>Privacy Policy</Link>
    </nav>
  );
}
